<template>
    <div class="modal fade" tabindex="-1" id="ExperimenteGratis">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content border-0">
                <div class="modal-body">
                    <div class="py-4 px-4">
                        <h3>Conheça agora!</h3>
                        <hr />
                        <p class="small">
                            Preencha os campos abaixo, para conhecer a SollAI de perto.
                        </p>
                        
                        <form class="" id="formExperimenteGratis">
                            <div class="row g-3 gx-4">
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="dados_nmUsuario">Nome</label>
                                        <div class="form-control-wrap">
                                            <input type="text" class="form-control" id="dados_nmUsuario" placeholder="Nome Completo" name="dados.nmUsuario" v-model="dados.nmUsuario" maxlength="100" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="dados_nmEmpresaInstituicao">Empresa/Instituição</label>
                                        <div class="form-control-wrap">
                                            <input type="text" class="form-control" id="dados_nmEmpresaInstituicao" placeholder="Empresa/Instituição" name="dados.nmEmpresaInstituicao" v-model="dados.nmEmpresaInstituicao" maxlength="100" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="dados_nrCnpj">CNPJ</label>
                                        <div class="form-control-wrap">
                                            <vue-mask id="dados_nrCnpj"
                                                      class="form-control"
                                                      v-model="dados.nrCnpj"
                                                      mask="AA.AAA.AAA/AAAA-00"
                                                      :raw="false"
                                                      :options="options" required>
                                            </vue-mask>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="dados_nrCelular">Celular</label>
                                        <div class="form-control-wrap">
                                            <vue-mask class="form-control"
                                                      id="dados_nrCelular"
                                                      v-model="dados.nrCelular"
                                                      mask="(00) 00000-0000"
                                                      :raw="false"
                                                      :options="optionsTelefone" required>
                                            </vue-mask>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="dados_dsEmail">Email</label>
                                        <div class="form-control-wrap">
                                            <input type="email" class="form-control" id="dados_dsEmail" placeholder="Email" name="dados.dsEmail" v-model="dados.dsEmail" maxlength="100" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="dados_nmUf">UF</label>
                                        <div class="form-control-wrap">
                                            <select class="form-control" id="dados_nmUf" name="dados.nmUf" v-model="dados.nmUf" required>
                                                <option value="0" selected disabled> -- Selecione --</option>
                                                <option value="AC">Acre</option>
                                                <option value="AL">Alagoas</option>
                                                <option value="AM">Amazonas</option>
                                                <option value="AP">Amapá</option>
                                                <option value="BA">Bahia</option>
                                                <option value="CE">Ceará</option>
                                                <option value="DF">Distrito Federal</option>
                                                <option value="ES">Espírito Santo</option>
                                                <option value="GO">Goiás</option>
                                                <option value="MA">Maranhão</option>
                                                <option value="MT">Mato Grosso</option>
                                                <option value="MS">Mato Grosso do Sul</option>
                                                <option value="MG">Minas Gerais</option>
                                                <option value="PA">Pará</option>
                                                <option value="PB">Paraíba</option>
                                                <option value="PR">Paraná</option>
                                                <option value="PE">Pernambuco</option>
                                                <option value="PI">Piauí</option>
                                                <option value="RJ">Rio de Janeiro</option>
                                                <option value="RN">Rio Grande do Norte</option>
                                                <option value="RO">Rondônia</option>
                                                <option value="RS">Rio Grande do Sul</option>
                                                <option value="RR">Roraima</option>
                                                <option value="SC">Santa Catarina</option>
                                                <option value="SE">Sergipe</option>
                                                <option value="SP">São Paulo</option>
                                                <option value="TO">Tocantins</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label class="form-label" for="dados_dsComoSoube">Como Soube</label>
                                        <div class="form-control-wrap">
                                            <select class="form-control" id="dados_dsComoSoube" name="dados.dsComoSoube" v-model="dados.dsComoSoube" required>
                                                <option value="0" selected disabled> -- Selecione --</option>
                                                <option value="Google">Google</option>
                                                <option value="E-mail Marketing">E-mail Marketing</option>
                                                <option value="Evento Negócios Públicos">Evento Negócios Públicos</option>
                                                <option value="Redes Sociais">Redes Sociais</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <button class="btn btn-primary w-100 mt-3" type="button" @click="enviar">Enviar</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>
    import vueMask from 'vue-jquery-mask'
    import { urlApi, avisoSucesso, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'ExperimenteGratis',
        components: {
            vueMask,
        },
        data: function () {
            return {

                dados: {
                    nmUsuario: null,
                    nmEmpresaInstituicao: null,
                    nrCnpj: '',
                    nrCelular: '',
                    dsEmail: null,
                    nmUf: 0,
                    dsComoSoube: 0,
                },

                options: {
                    placeholder: 'CNPJ',
                },
                optionsTelefone: {
                    placeholder: 'Telefone',
                },

            }
        },
        props: {
            showModal: Boolean,
        },
        computed: {
            
        },        
        methods: {
            enviar() {
                if (this.checkForm()) {
                    let $this = this;
                    axios.post(`${urlApi}/Utilidade/SolicitacaoContato`, $this.dados)
                        .then(res => {
                            if (res.data.success) {
                                // aviso ok
                                avisoSucesso("Sua solicitação de acesso foi realizada com sucesso. Aguarde nosso contato!");
                                $this.$refs['modal-experimente-gratis'].hide();
                            } else {
                                avisoErro("Não foi possível enviar sua solicitação.");
                            }
                        })
                        .catch(function(){
                            avisoErro("Não foi possível enviar sua solicitação.");
                        });
                }
                return false;
            },

            checkForm() {
                var form = document.getElementById('formExperimenteGratis')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            load() {
                 
            },

            close() {
                const myModalAlternative = new window.bootstrap.Modal('#ExperimenteGratis');
                myModalAlternative.hide();
            },
        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                const myModalAlternative = new window.bootstrap.Modal('#ExperimenteGratis');
                myModalAlternative.show();
            },
            
        }
        
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" >
    

</style>

